import {InsuranceVI} from "./insurance/vi";
import {DecisionVI} from "./decision/vi";
import {RecordVI} from "./record/vi";
import {CompetencyAssessmentVI} from "./competency-assessment/vi";
import {ReportVI} from "./report/vi";
import {OkrsVI} from "./okr/vi";

export const PersonnelVI = {
    ...InsuranceVI,
    ...DecisionVI,
    ...RecordVI,
    ...CompetencyAssessmentVI,
    ...ReportVI,
    ...OkrsVI
}